var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { TenantCache } from '../artworkProcessing/TenantCache';
import { getSubTenant } from '../services/SherbertService';
export class VistaAssetStoreUtilities {
    /**
     * Get all the sub tenants and updates the tenant cache
     */
    static getSubTenants(authProvider) {
        return __awaiter(this, void 0, void 0, function* () {
            let response;
            let attempts = 0;
            const maxAttempts = 20;
            if (Object.keys(TenantCache.tenantCache).length === 0) {
                try {
                    response = yield VistaAssetStoreUtilities.getTenants(authProvider);
                    this.setCache(response);
                }
                catch (error) {
                    // If the initial API call fails, continue to the while loop
                }
            }
            // Call subtenant API until we get response or response status is 200 until we've tried 20 times.
            while ((!response || response.status !== 200) && attempts < maxAttempts) {
                try {
                    response = yield VistaAssetStoreUtilities.getTenants(authProvider);
                    if (response.status === 200) {
                        this.setCache(response);
                        break;
                    }
                }
                catch (error) {
                    // If the API call in the loop fails, try again unless maxAttempts is reached
                }
                attempts++;
            }
            // If after all the attempts, the status is not 200, throw an error
            if (!response || response.status !== 200) {
                throw new Error('Failed to fetch subtenants after maximum attempts.');
            }
        });
    }
    /**
     * returns response of subtenant api.
     * @param {AuthProvider} authProvider authentication parameters for this method call.
     * @returns {Promise<any>} Returns Promise.Throws an error on subtenant failure.
     */
    static getTenants(authProvider) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = new Headers(yield authProvider.getAuthHeaders());
            let response = undefined;
            if (headers.get('Authorization')) {
                response = (yield getSubTenant({
                    queryParams: { includeSubTenants: true },
                    path: {
                        tenantId: VistaAssetStoreUtilities.vistaTenant,
                    },
                }, { headers }));
            }
            return response;
        });
    }
    static setCache(response) {
        return __awaiter(this, void 0, void 0, function* () {
            if (response && response.status && response.status === 200) {
                response.data.subTenants.forEach((tenant) => {
                    if (!TenantCache.tenantCache[tenant.id]) {
                        TenantCache.tenantCache[tenant.id] = tenant.id;
                    }
                });
            }
        });
    }
}
Object.defineProperty(VistaAssetStoreUtilities, "vistaTenant", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: '4HVsAccqLzE6BPbmvrDaKw'
});
//# sourceMappingURL=VistaAssetsStoreUtilities.js.map